/**
 * @generated SignedSource<<6c6e9f708eb4163e3f0677bcc3adb9b4>>
 * @relayHash 2eb9215dcb75b727e95841989367e296
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f2def9bf1b962d0fcf740a93d0c9507c7db2d4f91c94702c3c251ceb07c1f0d0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavQueueInnerQuery } from './HorizontalNavQueueInnerQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavQueueInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f2def9bf1b962d0fcf740a93d0c9507c7db2d4f91c94702c3c251ceb07c1f0d0",
    "metadata": {},
    "name": "HorizontalNavQueueInnerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
